/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum CcbSwitchPartner {
    CABLECO,
    CABLECO3,
    CABLECO5,
    CABLECO12,
    CLARO,
    LLA,
    MILLICOM,
    UNIT_TEST,
    VTR,
}
